export enum PurchaseOfferType {
	SUBSCRIPTION = 'SUBSCRIPTION'
}

export enum RequestCloseReasonType {
	LoadFailure = 'LoadFailure',
	UserCanceled = 'UserCanceled',
	WasSuccessful = 'WasSuccessful',
	// iOS native returns this if purchase flow does not return a reason
	PurchaseFailed = 'PurchaseFailed'
}

export interface PurchaseReceiptOffers {
	OfferId: string;
	OfferNamespace: string;
}

/** Launcher users lowercase property names*/
export interface PurchaseReceiptOffersLowercase {
	offerid: string;
	offernamespace: string;
}
export interface FormattedRewards {
	symbol?: string;
	decimals?: number;
	placement?: string;
	amount?: string;
	currency?: string;
	digits?: number;
}
export interface PurchaseReceipt {
	grantedVoucher: {
		amountDisplay: string;
		code: string;
		endDateDisplay: string;
		epicSalesEventId: string;
		epicSalesEventSlug: string;
		label: string;
		link: string;
		minSalesPriceDisplay: string;
		voucherImages: string;
	};
	Offers: PurchaseReceiptOffers[];
	TransactionId: string;
	TransactionState: string;
	earnedEpicRewards: {amount: number; currency: string};
	formattedEarnedEpicRewards: FormattedRewards;
}

/** Launcher users lowercase property names*/
export interface PurchaseReceiptLowercase {
	grantedvoucher: {
		amountdisplay: string;
		code: string;
		enddatedisplay: string;
		epicsaleseventid: string;
		epicsaleseventslug: string;
		label: string;
		link: string;
		minsalespricedisplay: string;
		voucherimages: string;
	};
	offers: PurchaseReceiptOffersLowercase[];
	transactionid: string;
	transactionstate: string;
	formattedearnedepicrewards: FormattedRewards;
}
